import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8 text-gray-800">
      <h1 className="text-3xl font-bold mb-6">
        Privacy Policy – Winik Properties LLC
      </h1>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">1. Introduction</h2>
        <p>
          Winik Properties LLC (“we,” “our,” or “us”) is a property management
          company based in the United States, committed to delivering
          exceptional services to property owners, tenants, investors, and
          businesses. This Privacy Policy explains how we collect, use, protect,
          and manage your personal information when you interact with us through
          our website at{" "}
          <a
            href="https://www.winikproperties.com"
            className="text-blue-600 underline"
          >
            www.winikproperties.com
          </a>{" "}
          or by other communication methods.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          2. Types of Information Collected
        </h2>
        <ul className="list-disc pl-6">
          <li>Full name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Mailing address</li>
          <li>Property ownership or rental details</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          3. How Information is Collected
        </h2>
        <ul className="list-disc pl-6">
          <li>Submit inquiries or service requests through our website</li>
          <li>Sign lease agreements or property management contracts</li>
          <li>Communicate with us by phone, email, or in person</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          4. Purpose of Data Collection
        </h2>
        <ul className="list-disc pl-6">
          <li>
            Provide and manage property management, preservation, and rental
            services
          </li>
          <li>
            Communicate important updates, notices, or account information
          </li>
          <li>Respond to inquiries and maintenance requests</li>
          <li>
            Maintain accurate records for business, legal, and accounting
            purposes
          </li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          5. Data Security Measures
        </h2>
        <p>
          We use administrative, technical, and physical safeguards to protect
          your personal information against unauthorized access, alteration,
          disclosure, or destruction. These measures include secure servers,
          encrypted communications, restricted employee access, and regular
          staff training in data privacy best practices.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">6. Data Sharing</h2>
        <p>
          We do not sell or rent your personal information. Your data will only
          be shared with trusted service providers (such as maintenance
          contractors, payment processors, or legal representatives) when
          necessary for business operations or as required by law.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">7. User Rights</h2>
        <ul className="list-disc pl-6">
          <li>Request access to the personal data we hold about you</li>
          <li>Update or correct any inaccuracies in your information</li>
          <li>
            Request deletion of your data, subject to contractual or legal
            obligations
          </li>
        </ul>
        <p className="mt-2">
          To exercise these rights, please contact us using the details below.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">8. Contact Information</h2>
        <p>
          Email:{" "}
          <a
            href="mailto:contact.winikproeprties@gmail.com"
            className="text-blue-600 underline"
          >
            contact.winikproeprties@gmail.com
          </a>
        </p>
        <p>
          Website:{" "}
          <a
            href="https://www.winikproperties.com"
            className="text-blue-600 underline"
          >
            www.winikproperties.com
          </a>
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">9. SMS Consent</h2>
        <p>
          By providing your phone number, you consent to receive SMS messages
          from Winik Properties LLC related to property management services,
          rental notifications, and updates. We will not share your phone number
          with third parties and will only use it for communication relevant to
          your account or inquiries.
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
